import React from "react";
import MainLayout from "../../components/layout/MainLayout";
import Image from "next/image";
import productTutorialImage from "../../../public/images/grill.jpg";

// Product Tutorial content component
const ProductTutorialContent = () => {
  return (
    <div className="w-full bg-guru-floral-white min-h-screen flex flex-col">
      {/* Header section with icon and title */}
      <div className="bg-[#FFF5F1] rounded-lg p-3 sm:p-4 mx-4 sm:mx-6 mt-4 sm:mt-6">
        <div className="flex items-center">
          <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#C4704B] rounded-lg flex items-center justify-center mr-3 sm:mr-4">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="w-6 h-6 sm:w-8 sm:h-8">
              <path d="M12 2L1 12h3v9h7v-6h2v6h7v-9h3L12 2zm0 2.84L19.93 12H18v7h-4v-6H10v6H6v-7H4.07L12 4.84z" />
            </svg>
          </div>
          <span className="text-lg sm:text-xl font-semibold">產品教學</span>
        </div>
      </div>

      {/* Image content area */}
      <div className="w-full flex-1 relative mt-4 sm:h-[500px] md:h-[700px] lg:h-[900px] xl:h-[1200px]">
        <Image
          src={productTutorialImage}
          alt="Product Tutorial Guide"
          fill
          className="object-cover"
          priority
          sizes="(max-width: 640px) 100vw, (max-width: 768px) 100vw, (max-width: 1024px) 100vw, 100vw"
        />
      </div>
    </div>
  );
};

// Main component
const Main = () => {
  return (
    <div className="w-full bg-white">
      <ProductTutorialContent />
    </div>
  );
};

// Page component
export default function ProductTutorialPage() {
  return (
    <MainLayout title="產品教學 | GuruGuruHK" url="/article/product-tutorial">
      <Main />
    </MainLayout>
  );
}
